<script lang="ts" setup>
import {ExtendedUser} from "@/types";
import {useDisplay} from "vuetify";
import UserSidebar from "@/Pages/users/layouts/components/UserSidebar.vue";

interface Props {
    user: ExtendedUser,
}

const props = defineProps<Props>()

const { mdAndUp } = useDisplay()
</script>

<template>
    <v-navigation-drawer
        :absolute="true"
        :sticky="true"
        class="pl-5 border-e-0 pt-5 pr-2"
        mobile-breakpoint="md"
        :width="mdAndUp ? 320 : undefined"
    >
        <user-sidebar
            :user="props.user"
            :mobile="false"
        />
    </v-navigation-drawer>
    <v-row class="fill-height mx-3 mx-md-0">
        <v-col
            cols="12"
            lg="10"
        >
            <user-sidebar
                class="d-block d-md-none"
                :user="props.user"
                :mobile="true"
            />
            <slot />
        </v-col>
    </v-row>
</template>

<style scoped>
</style>
